import React, { useState, useRef, useEffect } from "react";
import useAuth from "../../../../components/hooks/useAuth";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";
import { formatPhone } from "../../../../components/utils";


  const ViewBroadcastAddLead = (props) => {

    const {broadcastId,setShowAddLead} = props;

  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();
  const [leadNumber, setLeadNumber] = useState('');
  const [loading, setLoading] = useState(false);



  const addLead = async () => {
    setLoading(true)
     let response = await postApi("/api/v1/wpbroadcast/member/toggle/"+broadcastId, {
        'operation_type': 'add',
        'contacts' :[{
          phone_number:leadNumber
        }]
      });

       if (response.status == 'fail') {
        window.alert(response.message)
        setLoading(false)
      }else{
        setShowAddLead(false);
      }
      setLoading(false)
  }



  return (
                <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.35)', zIndex: 999999 }}>
                  <div style={{ width: 420, background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 6px 30px rgba(0,0,0,0.25)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                      <div style={{ fontSize: 18, fontWeight: 800, color: '#51a197' }}>Adicionar Lead</div>
                      <button onClick={() => setShowAddLead(false)} style={{ border: 'none', background: 'transparent', fontSize: 18, cursor: 'pointer' }}><i className="bi bi-x-lg"></i></button>
                    </div>
                    <div style={{ marginBottom: 8, color: '#666' }}>Informe o número do lead (formato: (99) 99999-9999)</div>
                    <input
                      type="text"
                   //   placeholder="+55 (99) 99999-9999"
                      value={leadNumber}
                      onChange={e => setLeadNumber(formatPhone(e.target.value))}
                      style={{ width: '100%', padding: 10, fontSize: 16, borderRadius: 8, border: '1px solid #e0e0e0', marginBottom: 12 }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                      <button onClick={() => setShowAddLead(false)} style={{ padding: '8px 12px', borderRadius: 8, background: '#f0f0f0', border: 'none', color: '#222', cursor: 'pointer' }}>Cancelar</button>
                      <button onClick={() => {
                      const clean = leadNumber.replace(/\D/g, '');
                      if (clean.length < 10) return;

                      addLead(); // 👈 usa sua função correta
                    }} style={{ padding: '8px 12px', borderRadius: 8, background: '#51a197', border: 'none', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>Salvar</button>
                    </div>
                         {loading && <Loader />}

                  </div>
                </div>
          
  );
};

export default ViewBroadcastAddLead;